import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHookSection } from './components/OpeningHookSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttemptsSection } from './components/FailedAttemptsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { SectionDivider } from './components/SectionDivider';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-cream selection:bg-gold/30 selection:text-burgundy-deep" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SectionDivider data-id="element-2" />
      <OpeningHookSection data-id="element-3" />
      <SectionDivider data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <SectionDivider data-id="element-6" />
      <FailedAttemptsSection data-id="element-7" />
      <SectionDivider data-id="element-8" />
      <MechanismSection data-id="element-9" />
      <SectionDivider data-id="element-10" />
      <WhatYouGetSection data-id="element-11" />
      <SectionDivider data-id="element-12" />
      <WhoIsForSection data-id="element-13" />
      <SectionDivider data-id="element-14" />
      <HowItWorksSection data-id="element-15" />
      <SectionDivider data-id="element-16" />
      <ProofSection data-id="element-17" />
      <SectionDivider data-id="element-18" />
      <FAQSection data-id="element-19" />
      <SectionDivider data-id="element-20" />
      <OfferSection data-id="element-21" />
      <Footer data-id="element-22" />
    </main>;
}